import NonTradedREITorBDCForm from "./NonTradedREITorBDCForm";

export default NonTradedREITorBDCForm;
